import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { z } from 'zod';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';
import { requireSystemAdmin } from '~/utils/guards';

/**
 * Coverage Report route (`/explorer/coverage`).
 * Super-admin only — cross-subsidiary enrichment-coverage dashboard. Lazy-loaded
 * (via the named `CoverageReportView` export) to keep it off the initial bundle.
 */
const CoverageReportView = lazy(() =>
  import('~/features/coverage-report/components/coverage-report-view').then((m) => ({
    default: m.CoverageReportView,
  })),
);

// Declares the section-wide subsidiary scope (`sc`) so the Explorer tab bar can
// carry the picked subsidiary onto this route — matches the sibling routes.
const searchSchema = z.object({
  sc: z.string().optional(),
});

export const Route = createFileRoute('/_authenticated/_tenant/explorer/coverage')({
  validateSearch: searchSchema,
  beforeLoad: requireSystemAdmin(),
  component: () => (
    <Suspense fallback={<PageSkeleton />}>
      <CoverageReportView />
    </Suspense>
  ),
});
